export enum AllergyEnum {
    'apiAllergyBase' = 'api/v1/allergy/',
    'apiDietBase' = 'api/v1/diet/'
}

export const AllergyNbMinToShowPagination = 20
